import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import React from 'react';
import { ApolloProvider } from '@apollo/client';

import client from './apollo-client';

if (import.meta.env.VITE_ENVIRONMENT_TYPE !== 'Production') {
  loadDevMessages();
  loadErrorMessages();
}

const ApolloClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ApolloProvider client={client}>
    {children}
  </ApolloProvider>
);

export default ApolloClientProvider;
